import MeEntity from "../Entities/MeEntity";
import Permissions from "../models/Permissions";
import Network from "../network/network";
import SessionCache from "../network/SessionCache";

export interface Session {
    /** Only when the session was just asked for; the account is never kept, see getSession. */
    me: MeEntity | null;
    permissions: Permissions;
}

/** Who is signed in and what they may do - the rights asked once an hour instead of once per opened mail, see SessionCache. */
export default class SessionService {
    private static readonly SESSION_ROUTE = "OutlookPlugin/Session";
    private static readonly ME_ROUTE = "Me";

    private readonly network: Network;

    constructor(network: Network) {
        this.network = network;
    }

    /**
     * Only the rights are kept. The account names the company the backend is in, which changes when the user
     * switches company anywhere else - kept for an hour, the add-in would save under the previous company's user.
     * A session that cannot be had is passed on and kept nowhere, so the next load asks again.
     */
    public getSession = async (): Promise<Session> => {
        const kept = SessionCache.read();
        if (Permissions.isComplete(kept?.Permissions)) {
            return { me: null, permissions: Permissions.fromDto(kept.Permissions) };
        }
        const session = await this.network.requestJsonPublicApi(SessionService.SESSION_ROUTE);
        if (typeof session?.Account?.UserId !== "number" || !Permissions.isComplete(session.Permissions)) {
            throw new Error("the session answer carries no account or not every right");
        }
        SessionCache.write({ Permissions: session.Permissions });
        return { me: MeEntity.fromOdata(session.Account, new MeEntity()), permissions: Permissions.fromDto(session.Permissions) };
    };

    /** The account on its own, for when the rights came from what was kept. */
    public getMe = async (): Promise<MeEntity> => {
        return MeEntity.fromOdata(await this.network.requestJsonPublicApi(SessionService.ME_ROUTE), new MeEntity());
    };
}
